'use strict';

wbApp.controller('AddressListCtrl', ['$scope', 'recipientSvc',
function ($scope, recipientSvc) {

    $scope.addressList = '';

    recipientSvc.getAddressList($scope.recipientList)
    .then(function (data) {
        $scope.addressList = data;
    });

}]);
